import {sendPdpViewedClickedEvent} from '../../jquery/algolia/algolia.tracking';

class ProductDetailController {
    /*@ngInject*/
    constructor($log, $rootScope, ProductDetailService, CommonService, $timeout) {
        $log.debug('ProductDetailController initialized');
        this.$log = $log;
        this.currentVariant = null;
        this.productDetailService = ProductDetailService;
        this.productSize = {};
        this.productSizes = window.productSizes == undefined ? {} : window.productSizes.sizes;
        this.isInYourClub = false;
        this.deliveryDate = null;
        this.percentageSavings = null;
        this.commonService = CommonService;
        this.isVariantSelecting = false;
        this.isVariantSelected = false;
        this.isForeignProduct = false;
        this.isOneSize = false;
        this.hasDummyVariant = false;
        this.firstVariantCode = null;
        this.showSize = 'eu';
        this.sendAlgoliaEvent = false;
        this.algoliaQueryId = null;

        let size = localStorage.getItem('selectedProductSize');
        if (size != null) {
            $timeout(() => {
                for (let i = 0; i < window.productSizes.sizes.length; i++) {
                    if (window.productSizes.sizes[i].valueEU === size) {
                        this.productSize.selected = this.productSizes[i];
                        this.loadVariantData(window.productSizes.sizes[i], false);
                    }
                }
            }, 1);
        }

        $rootScope.$on('variantDataSuccess', () => {
            let variantData = this.productDetailService.getVariantData();
            if (variantData != null) {
                this.productDetailService.setWarningSelectSize(false);
                this.isVariantSelecting = false;
                this.isVariantSelected = true;
                this.isForeignProduct = variantData.isForeignProduct;
            }
        });

        $rootScope.$on('personalizeRequestSuccess', () => {
            let personalizeRequestResponse = this.commonService.getPersonalizeRequestResponse();
            this.isInYourClub = personalizeRequestResponse.isInYourClub;
            this.deliveryDate = personalizeRequestResponse.deliveryDate;
            this.sendAlgoliaPdpViewedEvent();
        });
    }

    init(isForeign, isOneSize, firstVariantCode, hasDummyVariant) {
        this.isForeignProduct = isForeign;
        this.isOneSize = isOneSize;
        this.hasDummyVariant = hasDummyVariant;
        this.firstVariantCode = firstVariantCode;
        if (this.isOneSize) {
            this.loadVariantDataForCode(firstVariantCode, false);
        }
        this.sendAlgoliaEvent = true;
    }

    // deprecated
    updateCurrentVariant() {
        if (this.currentVariant == null) {
            this.productDetailService.setVariantData(null);
        } else {
            this.productDetailService.requestVariantData(this.currentVariant, false);
        }
    }

    loadVariantDataBySizeAndAddToCart(s2sSize, s2sSizeSys) {
        var formattedSize = s2sSize.endsWith('.0') || s2sSize.endsWith('.5') ? s2sSize : s2sSize + '.0';
        for (let i = 0; i < window.productSizes.sizes.length; i++) {
            if ((s2sSizeSys === 'EU' && window.productSizes.sizes[i].valueEU === formattedSize) ||
                (s2sSizeSys === 'UK' && window.productSizes.sizes[i].valueUK === formattedSize) ||
                (s2sSizeSys === 'US' && window.productSizes.sizes[i].valueUK === formattedSize)) {
                this.productSize.selected = this.productSizes[i];
                if (window.dataLayer !== undefined) {
                    dataLayer.push({
                        's2sSize': s2sSize,
                        's2sSizeSys': s2sSizeSys
                    });
                }
                this.loadVariantData(window.productSizes.sizes[i], true);
                return;
            }
        }
        console.log('s2s unknown size system: ' + s2sSizeSys + ', size: ' + s2sSize);
    }

    loadVariantData(variantOption, s2sAddToCart) {
        this.loadVariantDataForCode(variantOption.code, s2sAddToCart);
    }

    loadVariantDataButton(index) {
        this.productSize.selected = this.productSizes[index];
        this.loadVariantDataForCode(this.productSizes[index].code, false);
    }

    isButtonSelected(index) {
        if (this.productSizes[index] == this.productSize.selected) {
            return true;
        } else {
            return false;
        }
    }

    loadVariantDataForCode(variantCode, s2sAddToCart) {
        this.isVariantSelecting = true;
        this.productDetailService.requestVariantData(variantCode, s2sAddToCart);
    }

    getCurrentVariant() {
        return this.currentVariant;
    }

    getFormattedPrice(defaultPrice) {
        let variantData = this.productDetailService.getVariantData();
        return this.productDetailService.formatPrice(defaultPrice, variantData != null ? variantData.price : null);
    }

    getFormattedOldPrice(defaultPrice) {
        let variantData = this.productDetailService.getVariantData();
        return this.productDetailService.formatPrice(defaultPrice, variantData != null ? variantData.oldPrice : null);
    }

    getFormattedYourClubPrice(defaultPrice) {
        let variantData = this.productDetailService.getVariantData();
        return this.productDetailService.formatPrice(defaultPrice, variantData != null ? variantData.yourClubPrice : null);
    }

    getFormattedCommonPrice(defaultPrice) {
        let variantData = this.productDetailService.getVariantData();
        return this.productDetailService.formatPrice(defaultPrice, variantData != null ? variantData.commonPrice : null);
    }

    setPercentageSavings(savings) {
        this.percentageSavings = savings;
    }

    getPercentageSavings() {
        let variantData = this.productDetailService.getVariantData();
        return variantData != null ? variantData.percentageSavings : this.percentageSavings;
    }

    showWarningSelectSize() {
        return this.productDetailService.getWarningSelectSize();
    }

    isForeignProduct() {
        return this.isForeignProduct;
    }

    availableForCheckout() {
        return this.productDetailService.availableForCheckout();
    }

    availableForPickup() {
        let variantData = this.productDetailService.getVariantData();
        if (variantData != null) {
            return variantData.availableForPickup;
        }
        return true;
    }

    availableForPickupInDefaultPoS() {
        let variantData = this.productDetailService.getVariantData();
        if (variantData !== null) {
            return variantData.availableForPickupInDefaultPoS;
        }
        return false;
    }

    availableForPickupInPoS() {
        let variantData = this.productDetailService.getVariantData();
        if (variantData !== null) {
            return variantData.availableForPickupInPoS;
        }
        return false;
    }

    stockLevel() {
        let variantData = this.productDetailService.getVariantData();
        if (variantData !== null) {
            return variantData.stockLevel;
        }
        return 0;
    }

    getIsInYourClub() {
        return this.isInYourClub;
    }

    getDeliveryDate() {
        return this.deliveryDate;
    }

    triggerS2SBeginEvent() {
        if (window.dataLayer !== undefined) {
            dataLayer.push({'event': 'S2SBegin'});
        }
    }

    hasYourClubPrice(defaultPrice) {
        return this.getFormattedYourClubPrice(defaultPrice) != '';
    }

    isSizeAvailable(sizeValue) {
        return sizeValue !== "" && sizeValue !== "-";
    }

    switchShowSize(showSize) {
        this.showSize = showSize;
    }

    sendAlgoliaPdpViewedEvent() {
        if (this.sendAlgoliaEvent) {
            const searchParams = new URLSearchParams(window.location.search);
            let queryID = '';
            if (searchParams.has('queryId')) {
                queryID = searchParams.get('queryId');
                this.algoliaQueryId = `?queryId=${queryID}`;
            }

            let connectedObjectIds = [];
            if (this.isOneSize) {
                connectedObjectIds = [this.firstVariantCode];
                if (this.hasDummyVariant) {
                    connectedObjectIds = [this.firstVariantCode.slice(0, -3)];
                }
            } else {
                this.productSizes.forEach(function (size) {
                    connectedObjectIds.push(size.code);
                });
            }
            let objectID = connectedObjectIds[0];
            sendPdpViewedClickedEvent(objectID, connectedObjectIds)

            $('body').attr('data-algolia-queryId', queryID);

            this.sendAlgoliaEvent = false;
        }
    }
}

export default ProductDetailController;
